import experienceDetailBG from "assets/images/others/host-side-images/experienceDetailBG.png";
import { ReactComponent as LocationIcon } from "assets/images/svgs/locationDark.svg";
import { ReactComponent as CalandarIcon } from "assets/images/svgs/calendarDark.svg";
import { ReactComponent as ClockIcon } from "assets/images/svgs/clockdark.svg";
import bgAttendess from "assets/images/others/host-side-images/bgAttendess.png";
import Breadcrumb, { BreadcrumbLink } from "components/breadcrumbs";
import { siteRoutes } from "utils/helpers/enums/routes";
import { EventDTO } from "utils/helpers/models/shared/event.dto";
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import { getFilePathWithBackendUrl } from "utils/helpers/common/http-methods";
import { useEffect, useState } from "react";
import AttendingParticipants from "./attending-participants";
import RsvpBreadcrumb from "components/breadcrumbs/RsvpBreadcrumb";
import useRsvp from "containers/rsvp/useHooks";
import WorkshopSessionPopup from "components/popups/workshop-session";
import ExperienceDetailHeader from "components/experience-detail-header";
const Attendess: React.FC = () => {
  const { eventData } = useLocation().state as { eventData: EventDTO };
  const [tab, setTab] = useState<string>("participants");
  const navigate = useNavigate();
  const [workshopSessionModal, setWorkshopSessionModal] = useState(false);
  const [eventAttendance, setEventAttendance] = useState<any[]>([]);
  const { getEventAttendance } = useRsvp();

  const breadcrumbLinks: BreadcrumbLink[] = [
    { title: "Home ", path: siteRoutes.rsvpHome },
    { title: "Event Attendees", path: siteRoutes.rsvpAttendess },
  ];

  const tabs = [
    { title: "Participants", value: "participants" },
    { title: "Attending", value: "attending" },
  ];

  // hide button on the base of startTime
  const lastSession =
    eventData.workshopSessions[eventData.workshopSessions.length - 1];
  const lastSessionDateTime = new Date(
    `${lastSession.startDateWithMonthAndYear} ${lastSession.endTime}`
  );
  const hasStarted = new Date() >= lastSessionDateTime;

  const visibleSessions = eventData.workshopSessions.slice(0, 3);
  const hasMoreSessions = eventData.workshopSessions.length > 3;

  useEffect(() => {
    if (eventData?.id) {
      getEventAttendance(eventData.id, setEventAttendance);
    }
  }, [eventData?.id]);

  if (!eventData) {
    return <Navigate to={siteRoutes.experiences} />;
  }

  return (
    <div>
      <ExperienceDetailHeader
        event={eventData}
        breadcrumb={<RsvpBreadcrumb links={breadcrumbLinks} />}
        // onHostClick={goToHostDetail}
        onSeeMoreSessions={() => setWorkshopSessionModal(true)}
        // onAttendeesClick={goToAttendess}
        visibleSessions={visibleSessions}
        hasMoreSessions={hasMoreSessions}
        gradientClass="bg-custom-gradient-rsvp"
      />
      <div className="container my-5">
        <div className="border-r pr-3 md:pr-5">
          <div className="flex space-x-4 md:space-x-10 pb-2">
            {tabs.map((_tab, index) => (
              <button
                key={index}
                className={`text-base font-semibold pb-1 flex items-center ${
                  tab === _tab.value
                    ? "text-rsvpGreen border-b-2 border-rsvpGreen"
                    : "text-grayText hover:text-rsvpGreen"
                }`}
              >
                <span onClick={() => setTab(_tab.value)}>{_tab.title}</span>
              </button>
            ))}
          </div>
        </div>
        {tab === "participants" && (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 py-5">
            {eventData?.eventSubscriptions?.map((item) => (
              <div
                key={item.id}
                className="flex flex-col items-center justify-center px-4 py-6 rounded-lg  cursor-pointer"
                style={{ backgroundImage: `url(${bgAttendess})` }}
              >
                <div className="hover:scale-110 transition-transform duration-300">
                  <img
                    className="w-[98px] h-[98px] rounded-full"
                    src={concatPathWithBackendUrl(
                      item?.profilePicUrl?.fileDownloadUri
                    )}
                    alt={item?.firstName}
                  />
                </div>
                <span className="text-base font-semibold mt-2 text-blackie">
                  {item?.firstName} {item?.lastName}
                </span>
                <span className="text-sm mt-1 text-labelTextColor">
                  {item?.email}
                </span>
              </div>
            ))}
          </div>
        )}

        {tab === "attending" && (
          <AttendingParticipants
            participants={eventData?.eventSubscriptions.filter((item) =>
              eventAttendance
                .map((attendance) => attendance.userId)
                .includes(item.id)
            )}
            eventId={eventData?.id}
            workshopSessions={eventData?.workshopSessions}
            eventAttendance={eventAttendance}
          />
        )}
      </div>
      {workshopSessionModal && (
        <WorkshopSessionPopup
          isOpen={workshopSessionModal}
          onClose={() => setWorkshopSessionModal(false)}
          sessions={eventData?.workshopSessions}
        />
      )}
    </div>
  );
};

export default Attendess;
